import { render } from "./ProductStatementModal.vue?vue&type=template&id=23a5d9ee"
import script from "./ProductStatementModal.vue?vue&type=script&lang=js"
export * from "./ProductStatementModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__